import { useMemo, useRef, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

interface UseFiltersOptions {
  availableFilters?: string[];
  defaultFilter?: Record<string, string>;
}

const getAppliedFilters = (
  searchParams: URLSearchParams,
  availableFilters: UseFiltersOptions['availableFilters'] = [],
) => {
  const params = Object.fromEntries(searchParams);

  // Remove non filter params
  delete params.page;
  delete params.search;
  delete params.sortBy;
  delete params.orderDir;

  if (availableFilters.length > 0) {
    for (const key of Object.keys(params)) {
      if (!availableFilters.includes(key)) {
        // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete params[key];
      }
    }
  }

  return params;
};

export const useFilters = ({
  availableFilters = [],
  defaultFilter,
}: UseFiltersOptions = {}) => {
  const [searchParams] = useSearchParams();
  const defaultFilterApplied = useRef(!defaultFilter && !searchParams.size);

  const [drawerOpen, setDrawerOpen] = useState(false);

  const closeDrawer = () => setDrawerOpen(false);
  const openDrawer = () => setDrawerOpen(true);

  const filterData = useMemo(() => {
    if (defaultFilter && !defaultFilterApplied.current && !searchParams.size) {
      defaultFilterApplied.current = true;

      return defaultFilter;
    }

    return getAppliedFilters(searchParams, availableFilters);
  }, [availableFilters, defaultFilter, searchParams]);

  return { filterData, drawerOpen, closeDrawer, openDrawer };
};
